const SEO_COUNTERS = {
  YANDEX: 52552804,
  GOOGLE: 'G-8TNH6JBBDV',
  MAIL_RU: 3085370,
}

export {SEO_COUNTERS}
